import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AUTH_ENTRY_ROUTE } from '../auth-entry';
import { sanitizeInternalReturnUrl } from '../security/navigation-security';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(AuthService);

  if (auth.isLoggedIn()) {
    // Check if there's a pending return URL from the device auth flow
    const pendingReturnUrl = sanitizeInternalReturnUrl(sessionStorage.getItem('auth_return_url'), window.location.origin);
    sessionStorage.removeItem('auth_return_url');
    if (pendingReturnUrl) {
      // Only redirect if we're not already on the return URL path
      if (!state.url.startsWith(pendingReturnUrl.split('?')[0])) {
        router.navigateByUrl(pendingReturnUrl);
        return false;
      }
    }
    return true;
  }

  // Otherwise attempt to refresh session and load user
  return auth.refreshSession().pipe(
    map(() => {
      // Check for pending return URL after successful refresh
      const pendingReturnUrl = sanitizeInternalReturnUrl(sessionStorage.getItem('auth_return_url'), window.location.origin);
      sessionStorage.removeItem('auth_return_url');
      if (pendingReturnUrl) {
        router.navigateByUrl(pendingReturnUrl);
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigate([AUTH_ENTRY_ROUTE], {
        queryParams: { returnUrl: state.url }
      });
      return of(false);
    })
  );
};
